export enum UserIndentityStatusEnum {
    New = "NEW",
    Pending = "PENDING",
    Active = "ACTIVE",
    Outdated = "OUTDATED",
    Cancelled = "CANCELLED"
}